import React, { useState, useEffect } from 'react';

import DataAdminServiceFactory from '../services/DataAdminServiceFactory';

import { CaseFolderObject,  SiteModel } from '../models/DataAdminTypes';
import FolderContentsFlat from './sub/FolderContentsFlat';
import FolderContentsHierarchical from './sub/FolderContentsHierarchical';

interface FolderContentsProps {
  getAccessToken: () => Promise<string>;
  caseFolder: string,
  env: string,
  site: SiteModel|null;
  onBack: () => void;
}

const FolderContents: React.FC<FolderContentsProps> = ({ getAccessToken, env, site, caseFolder, onBack }) => { 
  const [loading, setLoading] = useState<boolean>(false);
  const [doReload, setDoReload] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [folderObjects, setFolderObjects] = useState<CaseFolderObject[]>([]);

  const isHierarchical = true;

  useEffect(() => {
    const dataAdminService = new DataAdminServiceFactory().create(env);
    const fetchFolderObjects = async (): Promise<void> => {
      if (!site) {
        setError('No site selected');
        setLoading(false);
        setFolderObjects([]);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const objects = await dataAdminService.getFolderObjects(await getAccessToken(), site.siteCode, caseFolder);
        setFolderObjects(objects);
      } catch (err) {
        setError('Failed to fetch folder contents.');
        console.error('Error fetching folder contents:', err);
      } finally {
        setLoading(false);
        setDoReload(false);
      }
    };

    if (site) {
      fetchFolderObjects();
    }
  }, [getAccessToken, doReload, env, site, caseFolder]);

  if (loading) {
    return <div>Loading folder contents...</div>;
  }

  return (
    <>
      
      {error && <div className="text-error">{error}</div>}

      {isHierarchical ? (
        <FolderContentsHierarchical 
          getAccessToken={getAccessToken}
          env={env}
          folderObjects={folderObjects}
          site={site}
          caseFolder={caseFolder}
          onBack={onBack}
          onReload={() => setDoReload(true)}  
        />
      ) : (
        <FolderContentsFlat 
          getAccessToken={getAccessToken}
          env={env}
          folderObjects={folderObjects}
          site={site}
          caseFolder={caseFolder}
          onBack={onBack}
          onReload={() => setDoReload(true)}  
        />
      )}

    </>
  );
  
};
export default FolderContents;
